import { useServices } from 'containers/services';
import { useQuery, type UseQueryOptions, type UseQueryResult } from 'react-query';
import { QUERY_KEYS } from 'utils/queryKeys';
import type { SerializedMeterAddon } from '@enmon/commons/lib/tools';
import type { Populate } from '@enmon/commons/lib/tools/utils/buildQuery';
import type { GetOneMeterModuleArg } from '../../../lib/services';

type UseOneMeterModuleArg = {
  moduleId: GetOneMeterModuleArg['moduleId'];
  populate?: Populate<SerializedMeterAddon>;
};

export const useOneMeterModule = (
  { moduleId, populate }: UseOneMeterModuleArg,
  options?: UseQueryOptions<SerializedMeterAddon, Error>,
): UseQueryResult<SerializedMeterAddon> => {
  const { meterModulesApiClient } = useServices();

  return useQuery({
    queryKey: QUERY_KEYS.meterModules.one(moduleId),
    queryFn: async ({ signal }) => await meterModulesApiClient.findOne({ moduleId, populate, signal }),
    ...options,
  });
};
